import Tools from "../../../base/components/tools";
import Mensajes from "./mensajes";

class CotizarFormulario extends React.Component {
  constructor() {
    super();

    this.state = {
      advancedOptionsExpanded: false,
      advancedOptionsActiveKey: null,
      showWarningIncludeMe: false,
    };

    this.messages = {
      name: {
        required: "El nombre es requerido",
        alphabetical: "El nombre no es correcto",
      },
      email: {
        required: "El email es requerido",
        email: "Por favor ingrese una dirección de correo",
      },
      cajaCategory: {
        required: "El campo categoría de caja es requerido",
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePanelSelect = this.handlePanelSelect.bind(this);
    //this.changePanelStatus = this.changePanelStatus.bind(this);
    this.subscribedCleanAll = this.subscribedCleanAll.bind(this);
    this.subscribedRemove = this.subscribedRemove.bind(this);
    this.calculator = this.calculator.bind(this);
    this.setCursorAtBegin = this.setCursorAtBegin.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    $(window).keyup((e) => {
      var code = e.keyCode ? e.keyCode : e.which;
      if (code == 9 && $("#email:focus").length && $("#email").val() == "@") {
        const input = document.getElementById("email");
        input.setSelectionRange(0, 0);
      }
    });
    if (!window.location.origin) {
      window.location.origin =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
    }

    this.tools = new Tools();
  }

  componentDidMount() {
    if (this.props.planvital) {
      let currentForm = JSON.parse(JSON.stringify(this.props.form));
      currentForm["caja"]["value"] = true;
      currentForm["eps"]["value"] = true;
      this.props.updateFormState(currentForm, true);
    }
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    this.props.updateFormState(currentForm, true);
  }

  removeEmojis(string) {
    const regex = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
    return string.replace(regex, "");
  }

  removeNonLetters(string) {
    const regex = /[^a-zA-Z\s]/gi;
    return string.replace(regex, "");
  }

  handleChange(event) {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    currentForm[event.target.id].value = event.target.value;
    if (event.target.id === "name") {
      currentForm[event.target.id].value = this.removeNonLetters(
        event.target.value
      );
    }
    this.props.updateFormState(currentForm);
  }

  handleBlur(event, elementId) {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    let element = event.target;
    this.props.saludValidaciones.validateField(element, currentForm);
    this.props.updateFormState(currentForm);
  }

  handleFocus(event) {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    if (!event.target.value) {
      currentForm[event.target.id].value = "@";
    }
    this.props.updateFormState(currentForm);
    if (
      currentForm[event.target.id] == "email" &&
      currentForm[event.target.id].value == "@"
    )
      this.setCursorAtBegin();
  }

  setCursorAtBegin() {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    if (currentForm["email"].value == "@") {
      const input = document.getElementById("email");
      input.setSelectionRange(0, 0);
    }
  }

  handleSwitch(value, field) {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    let sum =
      currentForm["lessthan60"].value + currentForm["morethan60"].value;

    // Bloquear acción si sum es igual a 20
    if (sum >= 20 && value) {
      this.setState({ showWarningIncludeMe: true });
      return;
    }

    if (field == "includeMe" && currentForm[field].value != value) {
      const moreOrLessThan60 = currentForm.isOlder.value
        ? "morethan60"
        : "lessthan60";

      currentForm[moreOrLessThan60].value = value
        ? currentForm[moreOrLessThan60].value + 1
        : currentForm[moreOrLessThan60].value - 1;

      if (field == "includeMe") {
        currentForm[field].value = value;
        this.props.updateFormState(currentForm, true);
      }
    }

    currentForm[field].value = value;

    if (!this.props.planvital || field === "includeMe") {
      this.props.updateFormState(currentForm, true);
    } else {
      this.showMessagesPlanVital();
    }

    // Ocultar mensaje si la acción es válida
    this.setState({ showWarningIncludeMe: false });
  }


  handleSelect(field, value) {
    let currentForm = JSON.parse(JSON.stringify(this.props.form));
    currentForm[field].value = value;
    this.props.saludValidaciones.validateField(
      { id: field, value: value },
      currentForm
    );
    this.props.updateFormState(currentForm, true);
  }

  subscribedCleanAll(event) {
    event.preventDefault();
    this.props.subscribedCleanAll(event);
    this.handlePanelSelect();
  }

  subscribedRemove(index, type, event) {
    event.preventDefault();
    this.props.subscribedRemove(index, type, () => {
      if (
        this.props.subscribed["lessthan60"].length +
        this.props.subscribed["morethan60"].length ==
        0
      ) {
        this.handlePanelSelect();
      }
    });
  }

  handlePanelSelect(advancedOptionsActiveKey) {
    let currentOptions = JSON.parse(JSON.stringify(this.props.options));
    if (advancedOptionsActiveKey) {
      currentOptions.advancedOptions =
        this.props.subscribed["lessthan60"].length +
        this.props.subscribed["morethan60"].length >
        0; //expanded && (this.props.subscribed['lessthan60'].length + this.props.subscribed['morethan60'].length > 0);
      this.props.updateOptionsState(currentOptions, true);
      this.setState({ advancedOptionsExpanded: true });
    } else {
      this.setState({ advancedOptionsExpanded: false });
    }
    this.setState({ advancedOptionsActiveKey });
  }

  calculator(type, operation, event) {
    event.preventDefault();
    this.props.calculator(type, operation, () => {
      if (
        this.props.subscribed["lessthan60"].length +
        this.props.subscribed["morethan60"].length ==
        0
      ) {
        this.handlePanelSelect();
      }
    });
  }

  /*changePanelStatus (expanded) {
        let currentOptions = JSON.parse(JSON.stringify(this.props.options));
        if (expanded) {
            currentOptions.advancedOptions = true;//expanded && (this.props.subscribed['lessthan60'].length + this.props.subscribed['morethan60'].length > 0);
            this.props.updateOptionsState(currentOptions, true);
        }
        this.setState({ advancedOptionsExpanded: expanded });
    }*/

  getSubscribed(type) {
    let categoria = this.props.planvital
      ? this.props.options.cajaCategories.filter(
        (item) =>
          item.CSTituloCategoriaText === "A" ||
          item.CSTituloCategoriaText === "B"
      )
      : this.props.options.cajaCategories;
    return this.props.subscribed[type].map((subscribed, index) => {
      return (
        <div className="subscribed">
          <div className="row">
            <div className="col-xs-3">
              <span
                className={
                  this.props.planvital
                    ? "subscribed-index-planvital subscribed-index"
                    : "subscribed-index"
                }
              >
                {index + 1}
              </span>
            </div>
            <div className="col-xs-9 text-right">
              <button
                className={
                  this.props.planvital
                    ? "btn btn-primary-planvital mr-10"
                    : "btn btn-primary mr-10"
                }
                onClick={(event) =>
                  this.props.subscribedCleanData(index, type, event)
                }
              >
                Limpiar datos
              </button>
              <span
                className={
                  this.props.planvital
                    ? "subscribed-remove subscribed-remove-planvital ml-10"
                    : "subscribed-remove ml-10"
                }
                onClick={(event) => this.subscribedRemove(index, type, event)}
                title="Eliminar Afiliado"
              >
                <i className="fa fa-trash"></i>
              </span>
            </div>
          </div>
          <hr />
          <form className="form-horizontal">
            <div
              className={
                "form-group" +
                (this.props.subscribed[type][index].form.name.valid
                  ? ""
                  : " has-error")
              }
            >
              <label htmlFor="name" className="col-sm-4 control-label">
                Nombre
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Ingresa tu nombre"
                  maxLength="105"
                  onBlur={(event) =>
                    this.props.subscribedHandleBlur(index, type, event)
                  }
                  onChange={(event) =>
                    this.props.subscribedHandleChange(index, type, event)
                  }
                  value={this.props.subscribed[type][index].form.name.value}
                />
                <p
                  className={
                    this.props.subscribed[type][index].form.name.valid
                      ? "hidden"
                      : "error"
                  }
                >
                  {
                    this.messages.name[
                    this.props.subscribed[type][index].form.name.error
                    ]
                  }
                </p>
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-4 col-xs-7 control-label">
                ¿Caja de Compensación Compensar?
              </label>
              <div className="col-sm-8 col-xs-5">
                <div className="cs-switch mt-5">
                  <div
                    className={
                      "cs-switch-option" +
                      (this.props.subscribed[type][index].form.caja.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() =>
                      this.props.subscribedHandleSwitch(
                        index,
                        true,
                        "caja",
                        type
                      )
                    }
                  >
                    Si
                  </div>
                  <div
                    className={
                      "cs-switch-option" +
                      (!this.props.subscribed[type][index].form.caja.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() => {
                      this.props.planvital
                        ? this.showMessagesPlanVital()
                        : this.props.subscribedHandleSwitch(
                          index,
                          false,
                          "caja",
                          type
                        );
                    }}
                  >
                    No
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                "form-group" +
                (!this.props.subscribed[type][index].form.caja.value
                  ? " hidden"
                  : "")
              }
            >
              <label
                htmlFor="cajaCategory"
                className="col-sm-4 col-xs-5 control-label"
              >
                Categoría de Caja de Compensación
              </label>
              <div className="col-sm-8 col-xs-7">
                <DropdownButton
                  title={
                    this.props.subscribed[type][index].form.cajaCategory
                      .value || "Seleccione"
                  }
                  id="cajaCategory"
                  className="dropdown-custom"
                  bsStyle="inline mt-5"
                  onSelect={(value) =>
                    this.props.subscribedHandleSelect(
                      index,
                      "cajaCategory",
                      type,
                      value
                    )
                  }
                >
                  {categoria.map((cajaCategory) => {
                    return (
                      <MenuItem
                        eventKey={cajaCategory.CSTituloCategoriaText}
                        className={
                          this.props.subscribed[type][index].form.cajaCategory
                            .value === cajaCategory.CSTituloCategoriaText
                            ? `${this.props.planvital
                              ? " hover-option-planvital"
                              : " active"
                            }`
                            : `${this.props.planvital
                              ? " hover-option-planvital"
                              : ""
                            }`
                        }
                      >
                        {cajaCategory.CSTituloCategoriaText}
                      </MenuItem>
                    );
                  })}
                </DropdownButton>
                {this.props.popovers["CategoriaCaja"] && (
                  <OverlayTrigger
                    trigger="click"
                    rootClose
                    placement={this.props.popovers["CategoriaCaja"].position}
                    overlay={this.props.getPopover("CategoriaCaja")}
                  >
                    <Button className="cs-popover mt-5">
                      <span
                        className={
                          this.props.planvital ? "info-circle-planvital" : ""
                        }
                      >
                        <i className="fa fa-info-circle"></i>
                      </span>
                    </Button>
                  </OverlayTrigger>
                )}
              </div>
            </div>
            {/* <div className="form-group">
              <label className="col-sm-4 col-xs-7 control-label">
                EPS Compensar
                <br />
                <span className="detail-label">¿Tiene EPS con Compensar?</span>
              </label>
              <div className="col-sm-8 col-xs-5">
                <div className="cs-switch mt-5">
                  <div
                    className={
                      "cs-switch-option" +
                      (this.props.subscribed[type][index].form.eps.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() =>
                      this.props.subscribedHandleSwitch(
                        index,
                        true,
                        "eps",
                        type
                      )
                    }
                  >
                    Si
                  </div>
                  <div
                    className={
                      "cs-switch-option" +
                      (!this.props.subscribed[type][index].form.eps.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() => {
                      this.props.planvital
                        ? this.showMessagesPlanVital()
                        : this.props.subscribedHandleSwitch(
                          index,
                          false,
                          "eps",
                          type
                        );
                    }}
                  >
                    No
                  </div>
                </div>
              </div>
            </div> */}
          </form>
          <hr />
        </div>
      );
    });
    return subscribed;
  }

  handleFormSubmit(e) {
    e.preventDefault();
    console.log("enter...");
  }

  showMessagesPlanVital() {
    this.refs.messagePlanvital.handleShow();
  }

  render() {
    let categoria = this.props.planvital
      ? this.props.options.cajaCategories.filter(
        (item) =>
          item.CSTituloCategoriaText === "A" ||
          item.CSTituloCategoriaText === "B"
      )
      : this.props.options.cajaCategories;
    let loginURL = "";
    if (Object.keys(this.props.configurations).length) {
      loginURL = this.tools.getLoginURL(this.props.configurations["FBA_CLAIM"]);
    }
    return (
      <div>
        <div
          className={
            "cotizar-is-authenticated" +
            (this.props.isAuthenticated ? " hidden" : "")
          }
        >
          Si tienes un usuario y contraseña Compensar{" "}
          <a href={loginURL}>Inicia Sesión</a> para una respuesta más detallada
          y para poder iniciar tu compra.
        </div>
        <div
          className={
            "cotizar-basic-form" +
            (this.props.isAuthenticated ? " border-top" : "")
          }
        >
          <h2 id="cotizar">
            Ingresa el número de personas a cotizar por grupo de edad
          </h2>
          <p className="note">
            {this.props.configurations["TextoIntroductorioSubSección"]}
          </p>
          <div className="form-horizontal basic-form">
            <div className="form-group mb-20">
              <label className="col-xs-5 col-sm-4 control-label">
                Menores de 60 años * <br />
                <span>Hasta 59 años</span>
              </label>
              <div className="col-xs-7 col-sm-8">
                <span
                  className={`cotizar-form-quantity ${this.props.planvital
                    ? "cotizar-form-quantity-planvital"
                    : null
                    } `}
                >
                  {this.props.form.lessthan60.value}
                </span>
                <div className="cotizar-form-controls">
                  <button
                    className={`${this.props.planvital
                      ? "cotizar-form-controls-action-planvital remove"
                      : "cotizar-form-controls-action remove"
                      }`}
                    onClick={(event) =>
                      this.calculator("lessthan60", "remove", event)
                    }
                    disabled={
                      this.props.form.lessthan60.value == 0 ||
                      (this.props.form.lessthan60.value == 1 &&
                        this.props.form.includeMe.value && !this.props.form.isOlder.value)
                    }
                  >
                    -
                  </button>
                  <button
                    className={`${this.props.planvital
                      ? "cotizar-form-controls-action-planvital add"
                      : "cotizar-form-controls-action add"
                      }`}
                    onClick={(event) =>
                      this.calculator("lessthan60", "add", event)
                    }
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            {!this.props.planvital ? (
              <div className="form-group mt-20">
                <label className="col-xs-5 col-sm-4 control-label">
                  Mayores de 60 años * <br />
                  <span>Desde 60 años</span>
                </label>
                <div className="col-xs-7 col-sm-8">
                  <span
                    className={`cotizar-form-quantity ${this.props.planvital
                      ? "cotizar-form-quantity-planvital"
                      : null
                      } `}
                  >
                    {this.props.form.morethan60.value}
                  </span>
                  <div className="cotizar-form-controls">
                    <button
                      className="cotizar-form-controls-action remove"
                      onClick={(event) =>
                        this.calculator("morethan60", "remove", event)
                      }
                      disabled={
                        this.props.form.morethan60.value == 0 ||
                        (this.props.form.morethan60.value == 1 &&
                          this.props.form.includeMe.value && this.props.form.isOlder.value)
                      }
                    >
                      -
                    </button>
                    <button
                      className="cotizar-form-controls-action add"
                      onClick={(event) =>
                        this.calculator("morethan60", "add", event)
                      }
                    >
                      +
                    </button>
                  </div>
                  {this.props.popovers && this.props.popovers["Mayores"] && (
                    <OverlayTrigger
                      trigger="click"
                      rootClose
                      placement={this.props.popovers["Mayores"].position}
                      overlay={this.props.getPopover("Mayores")}
                    >
                      <Button className="cs-popover">
                        <span>
                          {this.props.popovers["Mayores"].buttonText}{" "}
                          <i className="fa fa-info-circle"></i>
                        </span>
                      </Button>
                    </OverlayTrigger>
                  )}
                </div>
              </div>
            ) : null}

            <p className={this.props.options.showWarning ? "error" : "hidden"}>
              Señor usuario, la cotización solo se realizará para un número
              máximo de 20 afiliados
            </p>
          </div>
          <h2 className="mb-20">Datos del interesado</h2>
          <form className="form-horizontal">
            <div
              className={
                "form-group" + (this.props.form.name.value ? "" : " has-error")
              }
            >
              <label htmlFor="name" className="col-sm-4 control-label">
                Nombre *
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Ingresa tu nombre"
                  maxLength="105"
                  value={this.props.form.name.value}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                />
                <p className={this.props.form.name.valid ? "hidden" : "error"}>
                  {this.messages.name[this.props.form.name.error]}
                </p>
              </div>
            </div>
            <div
              className={
                "form-group" + (this.props.form.email.valid ? "" : " has-error")
              }
            >
              <label
                htmlFor="email"
                className="col-sm-4 control-label"
                maxLength="145"
              >
                Correo electrónico *
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Ingresa tu correo electrónico"
                  maxLength="245"
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  onClick={this.setCursorAtBegin}
                  value={this.props.form.email.value}
                />
                <p className={this.props.form.email.valid ? "hidden" : "error"}>
                  {this.messages.email[this.props.form.email.error]}
                </p>
              </div>
            </div>
            {(this.props.isAuthenticated ||
              this.props.options.advancedOptions ||
              !this.props.options.advancedOptions) && (
                <div className="form-group">
                  <label className="col-sm-4 col-xs-7 control-label">
                    ¿Caja de Compensación Compensar?
                  </label>
                  <div className="col-sm-8 col-xs-5">
                    <div className="cs-switch mt-5">
                      <div
                        className={
                          "cs-switch-option" +
                          (this.props.form.caja.value
                            ? `${this.props.planvital
                              ? " cs-switch-option-planvital"
                              : " active"
                            }`
                            : "")
                        }
                        onClick={() => this.handleSwitch(true, "caja")}
                      >
                        Si
                      </div>
                      <div
                        className={
                          "cs-switch-option" +
                          (!this.props.form.caja.value
                            ? `${this.props.planvital
                              ? " cs-switch-option-planvital"
                              : " active"
                            }`
                            : "")
                        }
                        onClick={() => this.handleSwitch(false, "caja")}
                      >
                        No
                      </div>
                    </div>
                  </div>
                </div>
              )}
            {(this.props.isAuthenticated ||
              this.props.options.advancedOptions ||
              !this.props.options.advancedOptions) && (
                <div
                  className={
                    "form-group" +
                    (this.props.form.cajaCategory.valid ? "" : " has-error") +
                    (!this.props.form.caja.value ? " hidden" : "")
                  }
                >
                  <label
                    htmlFor="cajaCategory"
                    className="col-sm-4 col-xs-5 control-label"
                  >
                    Categoría de Caja de Compensación
                  </label>
                  <div className="col-sm-8 col-xs-7">
                    <DropdownButton
                      title={this.props.form.cajaCategory.value || "Seleccione"}
                      id="cajaCategory"
                      className="dropdown-custom"
                      bsStyle="inline mt-5"
                      onSelect={(value) =>
                        this.handleSelect("cajaCategory", value)
                      }
                    >
                      {categoria.map((cajaCategory) => {
                        return (
                          <MenuItem
                            eventKey={cajaCategory.CSTituloCategoriaText}
                            className={
                              this.props.form.cajaCategory.value ===
                                cajaCategory.CSTituloCategoriaText
                                ? `${this.props.planvital
                                  ? " hover-option-planvital"
                                  : " active"
                                }`
                                : `${this.props.planvital
                                  ? " hover-option-planvital"
                                  : ""
                                }`
                            }
                          >
                            {cajaCategory.CSTituloCategoriaText}
                          </MenuItem>
                        );
                      })}
                    </DropdownButton>
                    {this.props.popovers &&
                      this.props.popovers["CategoriaCaja"] && (
                        <OverlayTrigger
                          trigger="click"
                          rootClose
                          placement={
                            this.props.popovers["CategoriaCaja"].position
                          }
                          overlay={this.props.getPopover("CategoriaCaja")}
                        >
                          <Button className="cs-popover mt-5">
                            <span
                              className={
                                this.props.planvital
                                  ? "info-circle-planvital"
                                  : ""
                              }
                            >
                              <i className="fa fa-info-circle"></i>
                            </span>
                          </Button>
                        </OverlayTrigger>
                      )}
                    <p
                      className={
                        this.props.form.cajaCategory.valid ? "hidden" : "error"
                      }
                    >
                      {
                        this.messages.cajaCategory[
                        this.props.form.cajaCategory.error
                        ]
                      }
                    </p>
                  </div>
                </div>
              )}
            {(this.props.isAuthenticated /* || this.props.options.advancedOptions || !this.props.options.advancedOptions */) && (
              <div className="form-group">
                <label className="col-sm-4 col-xs-7 control-label">
                  EPS Compensar
                  <br />
                  <span className="detail-label">
                    ¿Tiene EPS con Compensar?
                  </span>
                </label>
                <div className="col-sm-8 col-xs-5">
                  <div className="cs-switch mt-5">
                    <div
                      className={
                        "cs-switch-option" +
                        (this.props.form.eps.value
                          ? `${this.props.planvital
                            ? " cs-switch-option-planvital"
                            : " active"
                          }`
                          : "")
                      }
                      onClick={() => this.handleSwitch(true, "eps")}
                    >
                      Si
                    </div>
                    <div
                      className={
                        "cs-switch-option" +
                        (!this.props.form.eps.value
                          ? `${this.props.planvital
                            ? " cs-switch-option-planvital"
                            : " active"
                          }`
                          : "")
                      }
                      onClick={() => this.handleSwitch(false, "eps")}
                    >
                      No
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* {this.props.isAuthenticated && this.props.form.age && ( */}
            <div className="form-group">
              <label className="col-sm-4 col-xs-7 control-label">
                ¿Tu te vas a afiliar?
              </label>
              <div className="col-sm-8 col-xs-5">
                <div className="cs-switch mt-5">
                  <div
                    className={
                      "cs-switch-option" +
                      (this.props.form.includeMe.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() => this.handleSwitch(true, "includeMe")}
                  >
                    Si
                  </div>
                  <div
                    className={
                      "cs-switch-option" +
                      (!this.props.form.includeMe.value
                        ? `${this.props.planvital
                          ? " cs-switch-option-planvital"
                          : " active"
                        }`
                        : "")
                    }
                    onClick={() => this.handleSwitch(false, "includeMe")}
                  >
                    No
                  </div>
                </div>
                <p className={this.state.showWarningIncludeMe ? "error" : "hidden"}>
                  Señor usuario, la cotización solo se realizará para un número
                  máximo de 20 afiliados
                </p>
              </div>
            </div>
            {/* )} */}
          </form>
        </div>
        <PanelGroup
          className={
            "cotizar-advanced-form-accordion" +
            (this.props.subscribed["lessthan60"].length +
              this.props.subscribed["morethan60"].length ==
              0
              ? " hidden"
              : "")
          }
          accordion
          id="advanced-options-accordion"
          activeKey={this.state.advancedOptionsActiveKey}
          onSelect={this.handlePanelSelect}
        >
          <Panel eventKey="1" key="1">
            <Panel.Heading>
              <Panel.Title toggle>
                Opciones avanzadas
                <i
                  className={
                    "fa " +
                    (this.state.advancedOptionsExpanded
                      ? "fa-chevron-circle-up"
                      : "fa-chevron-circle-down")
                  }
                ></i>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <div className="cotizar-advanced-form">
                <div className="text-right">
                  <button
                    className={
                      this.props.planvital
                        ? "btn btn-default-planvital mb-10 mr-20"
                        : " btn btn-default mb-10 mr-20"
                    }
                    onClick={this.subscribedCleanAll}
                  >
                    Limpiar todos los datos
                  </button>
                </div>
                {this.props.options.advancedOptions && (
                  <p className="note">
                    {this.props.configurations["IngresaDatosBeneficiarios"]}
                  </p>
                )}
                <h3>Afiliados Menores de 60 años</h3>
                {this.getSubscribed("lessthan60")}
                {!this.props.planvital ? (
                  <h3>Afiliados Mayores de 60 años</h3>
                ) : null}
                {this.getSubscribed("morethan60")}
              </div>
            </Panel.Body>
          </Panel>
        </PanelGroup>

        <div className="cotizar-important hidden-xs">
          <strong>IMPORTANTE:</strong> {this.props.configurations["Importante"]}
        </div>
        <Mensajes
          ref="messagePlanvital"
          msg={this.props.configurations["noCambiaOpcion"]}
        />
      </div>
    );
  }
}

/******************** BUILD ********************/
let Panel = ReactBootstrap.Panel;
let PanelGroup = ReactBootstrap.PanelGroup;
let OverlayTrigger = ReactBootstrap.OverlayTrigger;
let DropdownButton = ReactBootstrap.DropdownButton;
let MenuItem = ReactBootstrap.MenuItem;
let Modal = ReactBootstrap.Modal;
let Button = ReactBootstrap.Button;
/******************** BUILD ********************/

export default CotizarFormulario;
